import React from 'react';
import {FlatList, Text, TouchableOpacity, View} from 'react-native';
import {styles} from './styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ChatComponent(props: any) {
  const {data, description, time, handleClick, checkResponse, response} = props;

  return (
    <View>
      {checkResponse && (
        <View style={styles.tchatBlockrWrap}>
          <View style={{flexDirection: 'column'}}>
            <Text style={styles.textTimes}>{time} </Text>
            <View style={styles.tchatBlockresponse}>
              <Text style={{color: 'white'}}>{response}</Text>
            </View>
          </View>
        </View>
      )}
      <Text style={styles.textTimes}>{time}</Text>
      <View style={styles.tchatBlock}>
        <Text style={{marginBottom: 8}}>{description}</Text>
        <FlatList
          scrollEnabled={false}
          data={data || []}
          keyExtractor={data.titre}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderItem={({item}: {item: any}) => (
            <TouchableOpacity
              style={styles.ListItemInRow}
              key={item.titre}
              onPress={() => {
                handleClick({item});
              }}>
              <Text style={styles.ListItemFont}>{item.titre}</Text>
            </TouchableOpacity>
          )}
        />
      </View>
    </View>
  );
}
